import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AccommodationPage from "@/pages/AccommodationPage";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/unitati-de-cazare" element={<AccommodationPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
